var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 109,
    viewBox: "0 0 147 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M91.8024 68.0765C91.8024 48.4229 96.5152 33.0362 105.941 21.9164C115.495 10.7966 128.859 3.4911 146.032 0V20.1708C132.991 24.1791 124.211 31.4199 119.692 41.8932C117.109 47.4531 116.076 52.8191 116.593 57.9911H147V109H91.8024V68.0765ZM0 68.0765C0 48.6815 4.58366 33.3594 13.751 22.1103C23.0474 10.8612 36.5402 3.4911 54.2292 0V20.1708C41.0593 24.3084 32.2148 31.4199 27.6957 41.5053C25.3715 46.8066 24.4032 52.3019 24.7905 57.9911H55.1976V109H0V68.0765Z",
    fill: "#E8E2E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComma);
export default __webpack_public_path__ + "static/media/comma.3cb6e9720b264f4f564f61d3987c7880.svg";
export { ForwardRef as ReactComponent };